import { jwtAuthAxios } from "../../shared/utils/network-utils";
import { OsaNodeCodingOperation } from "../models/OsaWaySnapshot";

export const OsaWaySnapshotApi = {
  getPreview: async (snapshotId: string) => {
    return await jwtAuthAxios().get<OsaNodeCodingOperation[]>(
      `/osa-way-snapshots/${snapshotId}/preview`
    );
  },

  apply: async (snapshotId: string) => {
    return await jwtAuthAxios().post(`/osa-way-snapshots/${snapshotId}/apply`);
  },
};
